<template>
  <b-form @submit.prevent="submitForm">
    <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
    <template v-if="!isLoading && passwordPolicy">
      <b-form-group>
        <template v-slot:label>{{ $t("currentPassword") }} <span class="text-danger">*</span></template>
        <b-form-input type="password" required v-model="currentPassword" />
        
      </b-form-group>
      <b-form-group :description="passwordPolicy.passwordDescription">
        <template v-slot:label>{{ $t("newPassword") }} <span class="text-danger">*</span></template>
        <b-form-input required v-model.trim="newPassword" type="text" autocomplete="off"
                      :minlength="passwordPolicy.minPasswordLength"
                      :maxlength="passwordPolicy.maxPasswordLength"
                      :pattern="passwordPolicy.passwordPattern"
                      @invalid.native="$event.target.setCustomValidity(passwordPolicy.passwordValidationFailedMessage)"
                      @input.native="$event.target.setCustomValidity('')"/>
      </b-form-group>
      <b-form-group>
        <template v-slot:label>{{ $t("confirmPassword") }} <span class="text-danger">*</span></template>
        <b-form-input type="text" class="masked-password" autocomplete="off" required v-model="confirmPassword" />
      </b-form-group>

      <div v-if="formErrorMsg" class="text-danger">{{ $t(formErrorMsg) }}</div>

      <div class="text-right pt-3">
        <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">
          {{ $t("cancel") }}
        </b-button>
        <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
      </div>
    </template>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue, Prop, Emit} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  // import environment from "@/environment";
  import * as userService from "@/service/userService";
  import * as passwordPolicyService from "@/service/passwordPolicyService";
  import {enumErrorType} from "@/views/enums/ErrorType";

  @Component
  export default class ChangePasswordModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;

    isLoading = true;
    passwordPolicy = null;

    currentPassword = "";
    newPassword = "";
    confirmPassword = "";

    formErrorMsg = "";
    isSubmitting = false;


    mounted() {
      this.fetchPasswordPolicy();
    }

    async fetchPasswordPolicy() {
      try {
        this.isLoading = true;
        this.passwordPolicy = await passwordPolicyService.get();

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
      }
    }

    onClickCancel() {
      this.$bvModal.hide(this.modalId);
    }

    async submitForm() {
      this.formErrorMsg = null;

      if (this.newPassword !== this.confirmPassword) {
        this.formErrorMsg = "passwordsNotMatch";
        return;
      }

      
      if (this.newPassword === this.currentPassword) {
      this.formErrorMsg = "passwordhasbeenusedbefore";
      return;
      }
      
      try {
        this.isSubmitting = true;
        await userService.changeMyPassword(this.currentPassword, this.newPassword);

        this.submitted();
        this.toastSuccessDelay(this.$t("passwordChangedSuccessful").toString());

        // sau khi thay doi thanh cong, he thong se thoat va quay ve man hinh dang nhap
        userService.signOut();

      } catch (e) {
        this.formErrorMsg = this.showError(e, enumErrorType.MESSAGE);
      } finally {
        this.isSubmitting = false;
      }
    }

    // Emit decorators only
    @Emit() submitted() {
      this.$bvModal.hide(this.modalId);
    }

  }
</script>
